module.exports = __webpack_public_path__ + "static/Marketing-87c209168dcd33e074b6206b6ec9a323.png";